import type { IStudentBadge } from '@/entities/Badges';
import { BadgeCard } from './BadgeCard';

interface AchievementsProps {
  data: IStudentBadge[];
}

// Весь список как пришёл: порядок админский, фильтровать нечего
export const Achievements = ({ data }: AchievementsProps) => {
  if (!data || data.length === 0) {
    return <div className="text-grey-secondary">No achievements available</div>;
  }

  return (
    <ul className="flex flex-wrap items-start justify-center gap-6">
      {data.map((badge: IStudentBadge) => (
        <BadgeCard key={badge.id} badge={badge} />
      ))}
    </ul>
  );
};
